import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
interface DashboardLayoutProps {
  children: React.ReactNode;
}
const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  children
}) => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  return <div className="flex h-screen bg-gray-100 dark:bg-gray-900" data-id="element-66">
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} data-id="element-67" />
      <div className="flex flex-col flex-1 overflow-hidden" data-id="element-68">
        <Header toggleSidebar={toggleSidebar} data-id="element-69" />
        <main className="flex-1 overflow-y-auto p-4 md:p-6" data-id="element-70">{children}</main>
      </div>
    </div>;
};
export default DashboardLayout;